import React from 'react';
export function Card({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`bg-white rounded-xl border border-gray-200 shadow-sm ${className}`} data-id="element-103">
      {children}
    </div>;
}